// extracted by mini-css-extract-plugin
module.exports = {"signUpGoogleButton":"editor-plugin_signUpGoogleButton__wipiy","inToolGoogleSignupButton":"editor-plugin_inToolGoogleSignupButton__tePap"};